<palantir-avatar-group
  [hoverExpansion]="true"
  [style.min-width.px]="avatars.length > maxItems ? (maxItems + 1) * 42 : maxItems * 42"
>
  @for (avatar of avatars.slice(0, maxItems); let index = $index; track avatar) {
    @if (avatar?.label) {
      <palantir-avatar
        [palantirTooltip]="avatar.label || ''"
        size="3xs"
        (click)="$event.stopPropagation(); action?.(avatar)"
        [style]="{ cursor: action ? 'pointer' : 'default' }"
        [fallbackText]="avatar?.label"
      >
        @if (avatar?.url) {
          <img [src]="avatar?.url" [alt]="avatar?.label" />
        }

        @if (avatar?.icon) {
          <palantir-icon [name]="avatar?.icon" />
        }

        @if (!avatar?.url && !avatar?.icon) {
          {{ avatar?.label || '?' }}
        }
      </palantir-avatar>
    } @else {
      <palantir-avatar
        size="3xs"
        (click)="$event.stopPropagation(); action?.(avatar)"
        [style]="{ cursor: action ? 'pointer' : 'default' }"
        [fallbackText]="avatar?.label"
      >
        @if (avatar?.url) {
          <img [src]="avatar?.url" [alt]="avatar?.label" />
        }

        @if (avatar?.icon) {
          <palantir-icon [name]="avatar?.icon" />
        }

        @if (!avatar?.url && !avatar?.icon) {
          {{ avatar?.label || '?' }}
        }
      </palantir-avatar>
    }
  }

  @if (avatars.length > maxItems) {
    <palantir-avatar [palantirTooltip]="extraItemsTooltip || extraAvatarTooltipsNames()" size="3xs">
      + {{ avatars.length - maxItems }}
    </palantir-avatar>
  }
</palantir-avatar-group>
